import { gql, useMutation } from "@apollo/client";
import {
  CashOutPointsMutationMutation,
  CashOutPointsMutationMutationVariables
} from "../../../schemaTypes";
import { pointsCardQuery } from "../PointsCard";
import { walletQuery } from "../../MyWallet";

export const cashOutPointsMutation = gql`
  mutation CashOutPointsMutation($points: Int!) {
    cashOutPoints(points: $points) {
      amount
      pointsSpent
      transactionId
      message
    }
  }
`;

/** Turns points into wallet money at the site's point value. */
export const useCashOutPoints = () => {
  const [mutate, { loading }] = useMutation<
    CashOutPointsMutationMutation,
    CashOutPointsMutationMutationVariables
  >(cashOutPointsMutation, { refetchQueries: [pointsCardQuery, walletQuery] });

  const cashOut = async (points: number) => {
    try {
      const { data } = await mutate({ variables: { points } });
      return { result: data?.cashOutPoints ?? null, error: null as string | null };
    } catch (err) {
      return { result: null, error: (err as Error).message || "Unable to cash out points right now." };
    }
  };

  return { cashOut, loading };
};
